import * as MD from "@material-ui/core/";
import * as React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { IApplicationState } from "../../Store";
import { ILayoutState } from "../../Store/Layout/Types";
import { I18N, ILocaleInfos } from "../../Store/I18n/Types";

import {
  IDashboardState,
  IDateType,
  IDisplayFormat,
} from "../../Store/Dashboard/Types";
import { DrawSelect } from "./DrawSelect";
import { ISearchState } from "../../Store/Search/Types";
import { PeriodSelection, PeriodSelectionComponent } from "../PeriodSelection";
import { hideDrawer, showDrawer } from "../../Store/Layout/Actions";

import { isNullOrUndefined } from "../../Utils/Various";
import {
  IStatsFilters1,
  IStatsFilters2,
  IStatsState,
} from "../../Store/Statistics/Types";
import {
  getStatisticsStep1,
  getStatisticsStep2,
} from "../../Store/Statistics/Actions";
import { IUserState } from "../../Store/User/Types";
import { PaletteMode } from "../../Themes";
import { RouteComponentProps } from "react-router-dom";
import { resetFilters } from "../../Store/Search/Actions";
import { Dialog } from "../Dialog";

interface IPropsFromState {
  i18n: I18N;
  layout: ILayoutState;
  localeInfos: ILocaleInfos;
  search: ISearchState;
  stats: IStatsState;
  user: IUserState;
  dashboard: IDashboardState;
  router: RouteComponentProps<{}>;
}

interface InitialState {
  openError: boolean;
  errorMessage: string;
  open: boolean;
  startDate: Date;
  endDate: Date;
  startSlot: Date;
  endSlot: Date;
  selectedYear: number;
  dateType: IDateType;
  // medias state
  mediasID: number[] | null;
  mediasStr: string[];
  isAllMediasSelected: boolean;
  // program types state
  programTypesID: number[] | null;
  programTypesStr: string[];
  isAllProgramTypesSelected: boolean;
  //datePicker
  isFullYearSelected: boolean;
  isSem1Activated: boolean;
  isSem2Activated: boolean;
  isTrim1Selected: boolean;
  isTrim2Selected: boolean;
  isTrim3Selected: boolean;
  isTrim4Selected: boolean;
  selectedMonthIndex: any;
  displayFormat: IDisplayFormat;
  periodTitle: string | undefined;
}

interface IOwnState {}

interface IPropsFromDispatch {
  getStatisticsStep1: typeof getStatisticsStep1;
  getStatisticsStep2: typeof getStatisticsStep2;
  hideDrawer: typeof hideDrawer;
  showDrawer: typeof showDrawer;
  resetFilters: typeof resetFilters;
}

interface ISearchProps {}

type IAppState = InitialState & IOwnState;

type AllProps = MD.WithTheme &
  MD.WithStyles<typeof styles> &
  IPropsFromState &
  IPropsFromDispatch &
  ISearchProps;

const styles = (theme: any) =>
  MD.createStyles({
    form: {
      marginTop: "-5px",
      display: "flex",
      flexFlow: "row",
      flexWrap: "wrap",
    },
    formControl: {
      width: "100%",
      marginTop: "5px",
    },
    focused: {},
    searchButton: {
      fontSize: 13,
      paddingTop: "0px",
      paddingBottom: "0px",
      marginLeft: "10px",
    },
    resetButton: {
      fontSize: 13,
      paddingTop: "0px",
      paddingBottom: "0px",
      marginRight: "10px",
    },
    datePicker: {
      borderBottom: "outset",
      borderBottomWidth: "1px",
    },
    monthButton: {
      padding: "5px 13.5px",
      maxWidth: "20px",
      maxHeight: "30px",
      minWidth: "20px",
      minHeight: "30px",
      borderRadius: "0px",
    },
    DateRange: {
      marginTop: "10px",
      color: "gray",
      border: "1px solid",
      backgroundColor: "#3e3c3c",
    },
    DateLabel: {
      fontSize: "13px",
      fontStyle: "italic",
      marginTop: "10px",
      paddingLeft: "10px",
      paddingBottom: "10px",
      color: "rgba(255, 255, 255, 0.7)",
    },
    dateRangePicker: {
      marginTop: "10px",
      backgroundColor: "white",
    },
    drawerPaper: {
      width: "300px",
      padding: "84px 15px 0px 15px",
      overflowX: "hidden",
      backgroundColor: theme.palette.background.default,
      border: "2px solid " + theme.palette.background.paper,
    },
    drawer: {
      "&.hidden": {
        width: "0px",
      },
      flexShrink: 0,
    },
    ifilters: {
      fontSize: "small",
      fontWeight: 500,
      backgroundColor: theme.palette.background.paper,
      display: "inline-flex",
      padding: "10px 10px 5px",
      marginBottom: "10px",
      position: "fixed",
      top: 40,
      left: 0,
      width: "100%",
      zIndex: 1201,
    },
  });

let endDate = new Date();
const initialState: InitialState = {
  openError: false,
  errorMessage: "",
  open: true,
  selectedYear: -1,
  dateType: "calendar",
  startDate: new Date(endDate.getFullYear(), endDate.getMonth(), 1),
  endDate: endDate,
  startSlot: new Date(0),
  endSlot: new Date(0),
  mediasID: null,
  mediasStr: [],
  isAllMediasSelected: true,
  programTypesID: null,
  programTypesStr: [],
  isAllProgramTypesSelected: true,
  isSem1Activated: false,
  isSem2Activated: false,
  isFullYearSelected: false,
  isTrim1Selected: false,
  isTrim2Selected: false,
  isTrim3Selected: false,
  isTrim4Selected: false,
  selectedMonthIndex: null,
  displayFormat: "duration",
  periodTitle: "",
};

export class StatsRepartitionDrawerComponent extends React.Component<
  AllProps,
  IAppState
> {
  private PeriodRef: React.RefObject<PeriodSelectionComponent>;

  public constructor(props: AllProps) {
    super(props);
    this.PeriodRef = React.createRef<PeriodSelectionComponent>();
    this.state = {
      ...initialState,
    };
  }
  componentDidMount() {}
  private handleClose = () => {
    this.setState({ openError: false });
  };

  private buildSearchButton() {
    return (
      <div style={{ width: "100%", marginBottom: "20px" }}>
        <MD.FormControl
          style={{ width: "50%" }}
          className={this.props.classes.formControl}
        >
          <MD.Button
            className={this.props.classes.resetButton}
            color="secondary"
            onClick={this.onReset.bind(this)}
            variant="contained"
          >
            {this.props.i18n._("Reset")}
          </MD.Button>
        </MD.FormControl>
        <MD.FormControl
          style={{ width: "50%" }}
          className={this.props.classes.formControl}
        >
          <MD.Button
            className={this.props.classes.searchButton}
            color="secondary"
            onClick={() => {
              this.onSearch();
            }}
            variant="contained"
          >
            {this.props.i18n._("Search")}
          </MD.Button>
        </MD.FormControl>
      </div>
    );
  }

  private saveDates(
    startDate: Date,
    endDate: Date,
    startSlot: Date,
    endSlot: Date,
    dateType: IDateType,
    periodTitle: string | undefined
  ) {
    this.setState({
      startDate,
      endDate,
      startSlot,
      endSlot,
      dateType,
      periodTitle,
    });
  }
  private onSearch() {
    const { i18n } = this.props;
    let msg: string = "",
      error: boolean = false,
      delimiter: string = "";
    if (this.state.mediasID !== null && this.state.mediasID.length === 0) {
      msg = i18n._("Please select a media !");
      error = true;
      delimiter = msg + "\n";
    }
    if (
      this.state.programTypesID !== null &&
      this.state.programTypesID.length === 0
    ) {
      msg = delimiter + i18n._("Please select a program type !");
      error = true;
    }
    this.setState({ openError: error, errorMessage: msg });
    if (
      !error &&
      this.state.programTypesID !== null &&
      this.state.mediasID !== null
    ) {
      let title: any =
        this.state.periodTitle === ""
          ? this.props.stats.periodTitle === ""
            ? `${this.state.startDate.toLocaleString(
                this.props.localeInfos.momentLocale
              )} 
            au ${this.state.endDate.toLocaleString(
              this.props.localeInfos.momentLocale
            )}`
            : this.props.stats.periodTitle
          : this.state.periodTitle;

      this.props.getStatisticsStep1(
        {
          mediasStr: this.state.mediasStr,
          mediasIds: this.state.mediasID,
          programTypesIds: this.state.programTypesID,
          programTypesStr: this.state.programTypesStr,
          startDate: this.state.startDate,
          endDate: this.state.endDate,
          show_pres: true,
        },
        title
      );
      this.props.hideDrawer();
    }
  }
  private onReset() {
    if (this.PeriodRef && this.PeriodRef.current) {
      this.PeriodRef.current!.onReset();
    }
    let endDate = new Date();
    if (this.props.dashboard.dateCloture !== null) {
      endDate = this.props.dashboard.dateCloture;
    }
    this.setState({
      ...initialState,
      selectedYear: endDate.getFullYear(),
      startDate: new Date(endDate.getFullYear(), endDate.getUTCMonth(), 1),
      endDate: endDate,
    });
    this.props.resetFilters();
  }
  componentWillUnmount() {
    this.props.showDrawer();
  }
  static getDerivedStateFromProps(props: AllProps, state: IAppState) {
    if (state.programTypesID === null) {
      if (
        props.search.searchFilters !== null &&
        props.search.searchFilters.program_types_str !== null
      ) {
        state.programTypesID = props.search.searchFilters.program_types_ids;
        state.programTypesStr = props.search.searchFilters.program_types_str;
        if (props.search.allProgramTypesID.length > 0) {
          state.isAllProgramTypesSelected =
            props.search.searchFilters.program_types_ids.length ===
            props.search.allProgramTypesID.length;
        }
      } else if (props.search.allProgramTypesID.length > 0) {
        state.programTypesID = props.search.allProgramTypesID;
        state.programTypesStr = props.search.allProgramTypesSTR;
      }
    }
    if (props.dashboard.dateCloture !== null && state.selectedYear === -1) {
      let endDate = props.dashboard.dateCloture;
      state.selectedYear = endDate.getUTCFullYear();
      if (props.search.searchFilters !== null) {
        let newStartDate = new Date(props.search.searchFilters.start_date);
        newStartDate.setHours(0);
        newStartDate.setMinutes(0);
        newStartDate.setSeconds(0);
        state.startDate = newStartDate;
        let newEndDate = new Date(props.search.searchFilters.end_date);
        newEndDate.setHours(0);
        newEndDate.setMinutes(0);
        newEndDate.setSeconds(0);
        state.endDate = newEndDate;
      } else {
        state.startDate = new Date(
          endDate.getUTCFullYear(),
          endDate.getUTCMonth(),
          1
        );
        state.endDate = endDate;
      }
    }
    if (state.mediasID === null) {
      state.isAllMediasSelected =
        props.user.allMediasID.length === 1 ? true : false;
      if (
        props.search.searchFilters !== null &&
        props.search.searchFilters.media_str !== null
      ) {
        state.mediasID = props.search.searchFilters.media_ids;
        state.mediasStr = props.search.searchFilters.media_str;
        if (props.user.allMediasID.length > 0) {
          state.isAllMediasSelected =
            props.search.searchFilters.media_ids.length ===
            props.user.allMediasID.length;
        }
      } else if (props.user.allMediasID.length > 0) {
        state.mediasID =
          props.user.allMediasID.length === 1 ? props.user.allMediasID : [];
        state.mediasStr =
          props.user.allMediasSTR.length === 1 ? props.user.allMediasSTR : [];
      }
      let title: any =
        state.periodTitle === ""
          ? props.stats.periodTitle === ""
            ? `${state.startDate.toLocaleString(
                props.localeInfos.momentLocale
              )} 
            au ${state.endDate.toLocaleString(props.localeInfos.momentLocale)}`
            : props.stats.periodTitle
          : state.periodTitle;
      if (state.mediasID !== null && state.programTypesID !== null) {
        props.getStatisticsStep1(
          {
            mediasStr: state.mediasStr,
            mediasIds: state.mediasID,
            programTypesIds: state.programTypesID,
            programTypesStr: state.programTypesStr,
            startDate: state.startDate,
            endDate: state.endDate,
            show_pres: true,
          },
          title
        );
      }
    }
    return state;
  }
  private buildFiltersInfos() {
    const { classes, i18n, theme } = this.props;
    let medias = this.state.mediasStr.filter((x) => x !== "").join(", ");
    let types = this.state.programTypesStr.filter((x) => x !== "").join(", ");
    return (
      <div
        className={classes.ifilters}
        style={{
          color:
            theme.palette.type === PaletteMode.DARK
              ? theme.palette.primary.main
              : theme.palette.secondary.main,
        }}
      >
        {("0" + this.state.startDate.getDate()).slice(-2)}-
        {("0" + (this.state.startDate.getMonth() + 1)).slice(-2)}-
        {this.state.startDate.getFullYear().toString().substring(2, 4)}
        {" " + i18n._("at") + " "}
        {("0" + this.state.endDate.getDate()).slice(-2)}-
        {("0" + (this.state.endDate.getMonth() + 1)).slice(-2)}-
        {this.state.endDate.getFullYear().toString().substring(2, 4)}
        {" > "}
        {i18n._("from")}{" "}
        {this.state.startDate.toTimeString().split(" ")[0].substring(0, 5)}{" "}
        {i18n._("to")}{" "}
        {this.state.endDate.toTimeString().split(" ")[0].substring(0, 5)}
        {this.state.mediasStr.length > 0 && " > "}
        {medias}
        {this.state.programTypesStr.length > 0 && " > "}
        {types}
      </div>
    );
  }
  private saveMediasChanges(ids: number[], str: string[], bool: boolean) {
    this.setState({
      mediasID: ids,
      mediasStr: str,
      isAllMediasSelected: bool,
    });
  }
  private saveProgramTypesChanges(ids: number[], str: string[], bool: boolean) {
    this.setState({
      programTypesID: ids,
      programTypesStr: str,
      isAllProgramTypesSelected: bool,
    });
  }
  public render(): React.ReactNode {
    const { classes, i18n, layout, theme } = this.props;
    let newState = { ...this.state };
    let errorMessageCopy: string = newState.errorMessage;

    return (
      <>
        {this.buildFiltersInfos()}
        <MD.Drawer
          anchor="left"
          classes={{ paper: classes.drawerPaper }}
          className={
            classes.drawer +
            (!isNullOrUndefined(layout.drawerContent) && layout.showDrawer
              ? ""
              : "hidden")
          }
          open={layout.showDrawer}
          variant="persistent"
        >
          <div>
            <span
              style={{ color: theme.palette.primary.main, fontStyle: "italic" }}
            >
              Statistiques / Répartitions
            </span>
            <form
              autoComplete={"off"}
              className={classes.form}
              noValidate={true}
            >
              {this.state.mediasID !== null && (
                <DrawSelect
                  i18n={i18n}
                  title={i18n._("Medias")}
                  list={this.props.user.medias}
                  listID={this.state.mediasID}
                  listStr={this.state.mediasStr}
                  isAllSelected={this.state.isAllMediasSelected}
                  allListIDs={this.props.user.allMediasID}
                  allListStr={this.props.user.allMediasSTR}
                  saveChanges={this.saveMediasChanges.bind(this)}
                  multiple={true}
                />
              )}
              {this.state.programTypesID !== null && (
                <DrawSelect
                  i18n={i18n}
                  title={i18n._("Program types")}
                  list={this.props.search.programTypes}
                  listID={this.state.programTypesID}
                  listStr={this.state.programTypesStr}
                  isAllSelected={this.state.isAllProgramTypesSelected}
                  allListIDs={this.props.search.allProgramTypesID}
                  allListStr={this.props.search.allProgramTypesSTR}
                  saveChanges={this.saveProgramTypesChanges.bind(this)}
                  multiple={true}
                />
              )}
              {/* {this.buildDatePicker()}  */}
              <PeriodSelection
                ref={this.PeriodRef}
                router={this.props.router}
                saveDates={this.saveDates.bind(this)}
                hideTime={true}
              />
              {this.buildSearchButton()}
            </form>
            <Dialog
              closeDialog={this.handleClose.bind(this)}
              open={this.state.openError}
              title={"Alert"}
              width={"350px"}
              content={
                <div>
                  {errorMessageCopy
                    .split("\n")
                    .map((paragraph: string, index: number) => {
                      return <p key={index}> {paragraph} </p>;
                    })}
                </div>
              }
              showActions={true}
            />
          </div>
        </MD.Drawer>
      </>
    );
  }
}
const mapStateToProps = (
  { layout, i18n, ui, search, stats, user, dashboard }: IApplicationState,
  ownProps: RouteComponentProps<{}>
) => ({
  layout,
  localeInfos: i18n.localeInfos,
  i18n: i18n.i18n,
  ui,
  search,
  stats,
  user,
  dashboard,
  router: ownProps,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  hideDrawer: () => dispatch(hideDrawer()),
  showDrawer: () => dispatch(showDrawer()),
  getStatisticsStep1: (
    filters: IStatsFilters1,
    periodTitle: string | undefined
  ) => dispatch(getStatisticsStep1(filters, periodTitle)),
  getStatisticsStep2: (filters: IStatsFilters2, total_duration_s: number) =>
    dispatch(getStatisticsStep2(filters, total_duration_s)),
  resetFilters: () => dispatch(resetFilters()),
});

export const StatsRepartitionDrawer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MD.withTheme(MD.withStyles(styles)(StatsRepartitionDrawerComponent)));
